import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from '../shared/interface/generic-interface';

@Injectable()
export class HeaderFilterService {

  constructor(private conService: ApiConService) { }

  async getListaGerentes() {
    try {
      const respListaGerentes: JsonReturn = await this.conService.patch('gerentes');
      return respListaGerentes.response;
    }catch (Error) {
      console.log("CATCH________getListaGerentes");
      console.log(Error);
    }
  }

  async getGerente(cd_gerencia: string) {
    try {
      const respGerente: JsonReturn = await this.conService.patch('gerentes/' + cd_gerencia);
      return respGerente.response;
    }catch (Error) {
      console.log("CATCH________getGerente");
      console.log(Error);
    }
  }

  async getListaEquipes() {
    try {
      const respListaEquipesPorGerente: JsonReturn = await this.conService.patch('equipes');
      return respListaEquipesPorGerente.response;
    }catch (Error) {
      console.log("CATCH________getListaEquipes");
      console.log(Error);
    }
  }

  async getEquipePorGerente(cd_gerencia: string) {
    try {
      const respListaEquipesPorGerente: JsonReturn = await this.conService.patch('equipes/' + cd_gerencia);
      return respListaEquipesPorGerente.response;
    }catch (Error) {
      console.log("CATCH________getEquipePorGerente");
      console.log(Error);
    }
  }

  async getListaMotoristas() {
    try {
      const respMotoristas: JsonReturn = await this.conService.patch('motoristas');
      return respMotoristas.response;
    }catch (Error) {
      console.log("CATCH________getListaMotoristas");
      console.log(Error);
    }
  }

  async getMotoristas(cd_equipe: string) {
    try {
      const respMotoristas: JsonReturn = await this.conService.patch('motoristas/' + cd_equipe);
      return respMotoristas.response;
    }catch (Error) {
      console.log("CATCH________getMotoristas");
      console.log(Error);
    }
  }

  async filtrarRoteiro(cd_gerencia: string, cd_equipe: string, cd_motorista: number) {
    try {
      const respMotoristas: JsonReturn = await this.conService.patch('roteiroVeiculo/' + cd_gerencia + '/' + cd_equipe + '/' + cd_motorista);
      return respMotoristas.response;
    }catch (Error) {
      console.log("CATCH________filtrarRoteiro");
      console.log(Error);
    }
  }
}
